import React from 'react'

export const MessageErrorUnstyled = props => (
  <div className={props.className}>{props.message}</div>
)



// WEBPACK FOOTER //
// ./src/Components/Message/Error/unstyled.js